import Navbar from "../../../components/Navbar/Navbar";
import Sidebar from "../../../components/SideBar/sidebar";
import BasicDetails from "../../../components/Profile/BasicDetails";
import BusinessProof from "../../../components/Profile/BusinessProof";
import ChangePassword from "../../../components/Profile/ChangePassword";
import MySubscription from "../../../components/Profile/MySubscription";
import ShopDetails from "../../../components/Profile/ShopDetails";
import React, { useEffect, useState } from "react";
import image from "../../../assets/Images/roundimage.png";
import noImage from "../../../assets/Images/noImage.jpg";
import { Image } from "antd";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import { useSelector } from "react-redux";
import BDODetails from "../../../components/Profile/BDODetails";
import { store } from "../../../Redux/store";
import { useTranslation } from "react-i18next";
import "../../../styles.css";
import {
  GetBankDetails,
  GetRetailerDetails,
} from "../../../API  Functions/ProfileFunctions";
import ShopLocation from "../../../components/Profile/ShopLocation";
import RetailerCommision from "../../../components/Profile/RetailerCommision";
import BankDetails from "../../../components/Profile/BankDetails";
import ETASetup from "../../../components/Profile/ETASetup";
import VatProductsScreen from "../../../components/Setting/VatProductsScreen";
import VATSetup from "../../../components/Profile/VATSetup";
import EtaSecretKeys from "../../../components/Profile/EtaSecretKeys";
import { getInventoryEditResttriction } from "../../../API  Functions/InventoryFunctions";
import DailySaleEmail from "../../../components/Profile/DailySaleEmail";

const Profile = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const userInfo = useSelector((state) => state?.login?.user?.result);
  const company_name = useSelector(
    (state) => state?.login?.user?.result?.company_name,
  );
  const selectedStore = useSelector((state) => state?.login?.selectedStore);
  const image_url = useSelector(
    (state) => state?.login?.user?.result?.image_url,
  );
  const is_retailer = useSelector(
    (state) => state?.login?.user?.result?.is_retailer,
  );
  const isMasterStore = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_master,
  );
  const contractType =
    useSelector((state) => state.login.contractType) || "Cashier_Ecom";

  const [retailerData, setretailerData] = useState("");
  const [bankData, setBankData] = useState([]);
  const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [selectedValue, setSelectedValue] = useState("My Profile");
  const [Profile, setprofile] = useState({ name: "", image: "" });

  useEffect(() => {
    fetchdetails();
    fetchBankdetails();
  }, []);

  useEffect(() => {
    CheckUserAcessForInventory();
  }, []);

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(user_id);
      if (res?.result?.status_code == 200) {
        setIsEtaEnable(res?.result?.is_eta_enabled);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result);
        setprofile({
          name: result?.retailer_details?.company_name,
          image: result?.retailer_details?.logo,
        });
        CheckUserAcessForInventory();
      }
    });
  };

  const fetchBankdetails = async () => {
    try {
      const res1 = await GetBankDetails(company_id);
      if (res1?.data?.result?.status === 200) {
        setBankData(res1.data.result.response);
      } else {
        setBankData([]);
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
    }
  };

  const payload = { user_id, store_id };

  const handleDataSubmit = () => fetchdetails();

  const data = [
    {
      name: "My Profile",
      component: (
        <BasicDetails
          payload={payload}
          onDataSubmit={handleDataSubmit}
          profiledetail={(val) => setprofile(val)}
          data={retailerData}
          fetchdetails={fetchdetails}
        />
      ),
    },
    {
      name: "shop_details",
      component: (
        <ShopLocation onDataSubmit={handleDataSubmit} data={retailerData} />
      ),
    },
    ...(is_retailer && !userInfo?.is_sub_store && !userInfo?.is_warehouse
      ? [
          {
            name: "Bank Details",
            component: (
              <BankDetails
                onDataSubmit={handleDataSubmit}
                data={bankData}
                onSubmit={fetchBankdetails}
              />
            ),
          },
        ]
      : []),
    {
      name: "business_proof",
      component: (
        <BusinessProof
          payload={payload}
          onDataSubmit={handleDataSubmit}
          data={retailerData}
        />
      ),
    },
    ...(is_retailer && !userInfo?.is_sub_store && !userInfo?.is_warehouse
      ? [
          {
            name: "Daily Sales Email",
            component: (
              <DailySaleEmail
                payload={payload}
                onDataSubmit={handleDataSubmit}
                data={retailerData}
              />
            ),
          },
        ]
      : []),
    ...(contractType !== "Cashier"
      ? [
          {
            name: "myGINNE Commission",
            component: <RetailerCommision />,
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="h-screen flex flex-col bg-[#F6F7F9]">
        <div className="sticky top-0 bg-[#F6F7F9]">
          <Navbar heading="My Profile" Profile={Profile} />
        </div>

        <div className="flex-1 overflow-hidden px-1 md:px-3 mt-4 mb-4">
          <div className="bg-white rounded-xl h-full flex flex-col">

            {/* ── Top Tab Bar (mirrors CashierSetupScreen) ── */}
            <div className="sticky top-0 z-40 bg-white border-b px-4 py-3 flex gap-4 overflow-x-auto">
              {data.map((val, i) => (
                <div
                  key={i}
                  onClick={() => setSelectedValue(val.name)}
                  className={`cursor-pointer px-4 py-2 rounded-md font-medium whitespace-nowrap transition-all
                    ${
                      selectedValue === val.name
                        ? "bg-[#E6F0FF] text-[#1D4ED8] border border-[#1D4ED8]"
                        : "text-[#6B7280] hover:bg-gray-100"
                    }`}
                >
                  {t(val.name)}
                </div>
              ))}
            </div>

            {/* ── Tab Content ── */}
            <div className="flex-1 overflow-y-auto custom-scrollbar p-2 md:p-4">
              {data.map((val, i) => (
                <div
                  key={i}
                  className={val.name === selectedValue ? "block" : "hidden"}
                >
                  {val.component}
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;

